module.exports = __webpack_public_path__ + "img/logo1.f0200a49.png";